@let entityDetail = level === 'Course' ? 'course' : 'course instance';
@let showFastlaneAlert = details.fastlaneEnabled && status.toLowerCase() === 'archive';

<mat-dialog-content>
  <div class="archive_popup_overlay">
    <div class="archive_popup">
      <div class="archive_title"> {{status}} <a class="material-icons" mat-dialog-close>close</a></div>
      <div class="user_name">Are you sure you want to {{status.toLowerCase()}} this {{entityDetail}}<span> {{name}}</span>?</div>
      @if (status.toLowerCase() === 'archive' && (institutionDetails?.fastLaneFlag || institutionDetails?.advertFlag)) {
        <p class="note_content">
          Note: The institution has the {{(institutionDetails?.fastLaneFlag && institutionDetails?.advertFlag) ? 'Fastlane and Advert' : (institutionDetails?.fastLaneFlag ? 'Fastlane' : 'Advert')}} flags enabled.
          {{showFastlaneAlert ? ('The ' + entityDetail + ' applicable for Fastlane(OIP)') : ''}}
        </p>
      }
      @if(showFastlaneAlert) {
        <p class="fastlane_enabled">
          <mat-checkbox class="checkbox_enabled" [(ngModel)]="fastlaneChecked"> I got concurrence from the Fastlane team for archiving this {{entityDetail}} </mat-checkbox>
        </p>
      }
      <div class="buttons_sec">
        <div class="btn_group">
          <button class="cancel_btn" mat-dialog-close>NO THANKS</button>
          <button class="save_btn" [ngClass]="{'disable_btn': showFastlaneAlert && !fastlaneChecked}" mat-stroked-button (click)="updatestatus()">YES</button>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
